import i18n from 'i18n';

const mainColumnHeaders = {
  rateNumber: i18n.t('rateNumber', { ns: 'rates' }),
  shippingLine: i18n.t('shipowner', { ns: 'rates' }),
  startPort: i18n.t('routeFrom', { ns: 'rates' }),
  endPort: i18n.t('routeTo', { ns: 'rates' }),
  containerType: i18n.t('containerType', { ns: 'rates' }),
  rateAllIn: i18n.t('rateAllIn', { ns: 'rates' }),
  dateFrom: i18n.t('dateFrom', { ns: 'rates' }),
  dateTo: i18n.t('dateTo', { ns: 'rates' }),
  publicationDate: i18n.t('publicationDate', { ns: 'rates' }),
};

const collapsedColumnHeaders = {
  contractNumber: i18n.t('contractNumber', { ns: 'rates' }),
  tradeType: i18n.t('tradeType', { ns: 'rates' }),
  commodities: i18n.t('commodity', { ns: 'rates' }),
  namedAccounts: i18n.t('namedAccount', { ns: 'rates' }),
  region: i18n.t('region', { ns: 'rates' }),
  stormRateJobs: i18n.t('activities', { ns: 'rates' }),
  daysOff: i18n.t('daysOff', { ns: 'rates' }),
  note: i18n.t('internalNote', { ns: 'rates' }),
};

const DATA_LABEL = i18n.t('data', { ns: 'rates' });
const RATE_LABEL = i18n.t('rate', { ns: 'rates' });

export { DATA_LABEL, RATE_LABEL, collapsedColumnHeaders, mainColumnHeaders };
